import { Entity, RELATION_PART_OF, SystemEntity } from '@backstage/catalog-model';
import {
  EntityLayout,
  RelatedEntitiesCard,
} from '@backstage/plugin-catalog';
import { columnFactories } from '@backstage/plugin-catalog-react';
import { Grid } from '@material-ui/core';
import React from 'react';

import { CustomDomainEntityLayout } from '../../../pages/EntityLayout/CustomDomainEntityLayout';

import { EntityDomainPageAboutCard } from '@internal/plugin-domain-page-about-card';
import { columnFactories as customColumns } from '../../../pages/CatalogTable/columns';
import { BusinessComponentsCard, CapabilityProductBoundaryComponentsCard } from './SystemPage';
import GraphCard from '../../EntityCatalogGraphCard';

export const capabilityPage = (
  <CustomDomainEntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <Grid item md={6} xs={12}>
          <EntityDomainPageAboutCard variant="gridItem" />
        </Grid>
        <Grid item md={6} xs={12}>
          <GraphCard isDefault height={400} />
        </Grid>
        <Grid item md={12} xs={12}>
          <RelatedEntitiesCard<SystemEntity>
            variant="gridItem"
            title="Products"
            entityKind="system"
            relationType={RELATION_PART_OF}
            columns={[customColumns.createProductColumn() as any, columnFactories.createOwnerColumn(), columnFactories.createMetadataDescriptionColumn()]}
            asRenderableEntities={(entities: Entity[]) => entities as SystemEntity[]}
            emptyMessage="No products found"
            emptyHelpLink="No Products are linked to this Capability."
          />
        </Grid>
      </Grid>
    </EntityLayout.Route>

<EntityLayout.Route path="/component" title="Tech Components">
      <CapabilityProductBoundaryComponentsCard />
    </EntityLayout.Route>

    <EntityLayout.Route path="/businessComponents" title="Business Components">
      <BusinessComponentsCard />
    </EntityLayout.Route>
  </CustomDomainEntityLayout>
);